import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEvetroLogoCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "512px",
	height: "512px",
	viewBox: "0 0 512 512",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path",
		d: "M252.96,221.61 C256.67,221.05 260.23,221.14 263.04,223.95 C270.61,231.36 278.03,238.98 285.61,246.39 C288.54,249.22 290.48,252.8 289.67,256.99 C289.31,260.08 287.14,261.98 285.11,264.11 C277.87,271.21 270.75,278.43 263.57,285.58 C260.74,288.53 256.74,289.14 252.88,288.26 C249.12,287.27 246.22,283.14 243.43,280.57 C237.76,274.9 232.1,269.24 226.39,263.61 C224.5,261.61 222.68,259.87 222.34,256.99 C221.41,253 223.21,249.69 225.9,246.91 C232.9,239.91 239.97,232.97 246.9,225.9 C248.62,224.22 250.56,222.21 252.96,221.61 Z",
		fill: "#00C6AE"
	})
});
export default SvgEvetroLogoCenter;
